<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  created() {
    if (!this.$store.getters.isSysInit) {
      var that = this
      this.$query('/api/launch/queryConfig', {}, function(res) {
        that.$store.dispatch('banner', res['banner'])
        that.$store.dispatch('codelist', res['codelist'])
        that.$store.dispatch('properties', res['properties'])
      })
    }
  },
}
</script>
<style>
#app {
  font-family: Helvetica Neue, Helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 16px;
  color: #2c3e50;
  background-color: #f5f5f5;
}

#nav {
  text-align: center;
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
a,
article,
aside,
b,
body,
button,
dd,
div,
dl,
dt,
figcaption,
figure,
footer,
h1,
h2,
h3,
h4,
h5,
h6,
header,
i,
input,
li,
nav,
p,
section,
select,
span,
textarea,
ul {
  padding: 0;
  margin: 0;
  list-style: none;
  font-style: normal;
  text-decoration: none;
  border: none;

  font-weight: 400;
  font-family: Microsoft Yahei;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
  -webkit-font-smoothing: antialiased;
}
a:hover,
article:hover,
aside:hover,
b:hover,
body:hover,
button:hover,
dd:hover,
div:hover,
dl:hover,
dt:hover,
figcaption:hover,
figure:hover,
footer:hover,
h1:hover,
h2:hover,
h3:hover,
h4:hover,
h5:hover,
h6:hover,
header:hover,
i:hover,
input:hover,
li:hover,
nav:hover,
p:hover,
section:hover,
select:hover,
span:hover,
textarea:hover,
ul:hover {
  outline: none;
}
a,
article,
aside,
b,
body,
button,
dd,
div,
dl,
dt,
figcaption,
figure,
footer,
h1,
h2,
h3,
h4,
h5,
h6,
header,
i,
input,
li,
nav,
p,
section,
select,
span,
textarea,
ul {
  padding: 0;
  margin: 0;
  list-style: none;
  font-style: normal;
  text-decoration: none;
  border: none;

  font-weight: 400;
  font-family: Microsoft Yahei;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
  -webkit-font-smoothing: antialiased;
}

ul {
  display: block;
  list-style-type: disc;
  margin-block-start: 1em;
  margin-block-end: 1em;
  /* margin-inline-start: 0px;
  margin-inline-end: 0px;
  padding-inline-start: 40px; */
}
.van-toast__text,
.van-toast__icon {
  color: #fff;
}

body {
  color: #333;
}
.van-popup--top {
  bottom: 0 !important;
  top: unset !important;
  background: #dea767 !important;
  color: red !important;
}
</style>
